import { TTimelineEvent } from "../BooleanTimeline/BooleanTimeline"
import { useMemo } from "react"
import { differenceInSeconds } from "date-fns"
import { TimeSeriesStatisticsItem } from "../TimeSeriesStatisticsItem"
import { themedUseStyletron } from "../../../theme/customTheme"
import { useIntl } from "react-intl"


const BooleanTimeseriesStatistics = (props: { data: TTimelineEvent[], start: Date, end: Date, color?: string, label?: any }) => {
    const [,theme] = themedUseStyletron();
    const intl = useIntl();
    const { numberOfOn, duration, percentageOn } = useMemo(() => {
        const numberOfOn = props.data.filter(v => v.value === true).length;
        const duration = props.data?.filter((v) => v.value === true)?.reduce((partialSum, a) => partialSum + (a.endDate.getTime() - a.startDate.getTime()), 0)
        const timeRange = differenceInSeconds(props.end, props.start);
        const durationSec = duration / 1000;
        const percentageOn = (durationSec / timeRange * 100).toFixed(1);
        return { numberOfOn, duration, percentageOn }
    }, [props.data])


    return (

        <TimeSeriesStatisticsItem
            color={props.color ?? theme.appColors.aggregate.on}
            percentage={Number(percentageOn)}
            count={numberOfOn}
            label={props.label ?? intl.formatMessage({id:"Devices.ON",defaultMessage: 'ON' })}
            duration={duration}
        ></TimeSeriesStatisticsItem>
    )
}

export default BooleanTimeseriesStatistics;